import React from 'react';

const steps = [
  {
    title: '步骤1',
    desc: '扫码/微信搜索服帮帮，进入小程序主页',
    img: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714163702_B5myyB.jpg',
  },
  {
    title: '步骤2',
    desc: '点击我的进入登陆页面进行登陆',
    img: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714182118_omGX4b.jpg',
  },
  {
    title: '步骤3',
    desc: '个人中心 申请认证',
    img: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714182149_zxERep.jpg',
  },
  {
    title: '步骤4',
    desc: '选择认证角色类型',
    img: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714182205_5Ab4zN.jpg',
  },
  {
    title: '步骤5',
    desc: '上传营业执照（正副本/电子版均可）',
    img: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714182218_xw0Tff.jpg',
  },
  {
    title: '步骤6',
    desc: '准备资料（加工厂为例）等待线下审核',
    img: 'https://fbb.obs.cn-east-3.myhuaweicloud.com/jpg/20250714182231_gXt1OQ.jpg',
  },
];

const Join: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Section A 顶部引导 */}
      <section className="bg-blue-100 pt-36 pb-24 mt-16">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4 text-blue-800">服帮帮入驻流程引导</h1>
          <p className="text-xl text-blue-700">仅需六步，轻松入驻</p>
        </div>
      </section>

      {/* Section B 六步流程 */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {steps.map((step, idx) => (
              <div key={idx} className="flex flex-col items-center bg-white rounded-xl shadow p-6">
                <div className="w-full md:h-60 mb-4 rounded-lg border border-gray-200 md:overflow-hidden">
                  <img src={step.img} alt={step.title} className="w-full h-full object-cover" />
                </div>
                <div className="text-2xl font-bold text-blue-700 mb-2">{step.title}</div>
                <div className="text-gray-700 text-lg text-center">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Join; 